import React from "react";
import { Button } from "antd";
import HoverQr from "../components/HoverQr";
import "../styles/Home.scss";

const Home: React.FC = () => {
  return (
    <>
      <div className="home-header-wrap">
        <div className="home-header">
          <div className="left">
            <img
              className="logo"
              src="https://static.pqmagic.cn/magic-web/img/icon.png"
              alt=""
            />
            <div className="logo-text">魔术师</div>
          </div>
          <div className="right">
            <a href="https://pqmagic.cn/login">登录</a>
          </div>
        </div>
      </div>
      <div className="home-landing">
        <div className="bg-image"></div>
        <div className="home-landing__hero">
          <div className="home-landing__title">
            <span className="brand">魔术师</span>
            插件-拼多多电商专属运营神器
          </div>
          <div className="home-landing__subtitle">全面兼容市面主流浏览器</div>
          <div className="home-landing__cta">
            <Button type="primary" size="large" shape="round">
              前往下载
            </Button>
          </div>
        </div>

        <div className="home-landing__body">
          <div className="home-landing__body-item">
            <span>业务简介：</span>
            <br />
            专注拼多多电商平台，为百万拼多多商家提供便捷开店工具，包括且不限于：活动报名、商品裂变、一键申诉差评等等
          </div>
          <div className="home-landing__body-item">
            <span>公司地址：</span>
            <br />
            深圳市龙岗区坂田街道马安堂社区新河街2号金方华电商产业园2栋602-01
          </div>
        </div>
        {/* <div className="home-landing__kefu">
          <HoverQr placement="left" contentWidth={180}>
            <div className="home-landing__kefu-text">客服咨询</div>
          </HoverQr>
        </div> */}
      </div>
      <div className="home-footer-wrap">
        <div className="home-footer-box">
          <div className="footer-item">
            <HoverQr placement="top" contentWidth={180}>
              <div className="footer-link">联系我们</div>
            </HoverQr>
          </div>
          <div className="footer-item">
            <div className="footer-link">联系电话：+86-13317956127</div>
          </div>
          <div className="footer-item">
            <a
              className="footer-link"
              href="https://beian.miit.gov.cn/#/Integrated/recordQuery"
            >
              IPC 编号：粤ICP备2025481786号-1
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
